import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import closeIcon from "../../../../../assets/icons/dashboard-x-close.svg";
import React from "react";
import ImageGroupForm from "../../ImageGroupForm/ImageGroupForm";
import { useTranslation } from "react-i18next";

function ImageGroupModal({ id, open, handleClose, data, ...rest }) {
  const { t } = useTranslation("image-group");

  return (
    <Dialog
      open={open}
      onClose={(_, reason) => reason === "escapeKeyDown" && handleClose(id)}
      className="ta-modal dashboard-image-group-modal"
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "829px"
          }
        }
      }}
    >
      <DialogTitle id="alert-dialog-title" className="modal_title">
        <span className="label">{data?.isEdit ? t("image-group-17") : t("image-group-18")}</span>
        <span className="close-btn" onClick={() => handleClose(id)}>
          <img src={closeIcon} alt="" />
        </span>
      </DialogTitle>
      <p className="subtitle">{data?.isEdit ? t("image-group-19") : t("image-group-20")}</p>
      <DialogContent className="ta-modal-content-scroll">
        <ImageGroupForm
          isEdit={data?.isEdit || false}
          id={data?.isEdit ? data?.id : null}
          group={data?.isEdit ? data?.group : null}
        />
      </DialogContent>
    </Dialog>
  );
}

export default ImageGroupModal;
